<script>
	import { params, afterPageLoad, goto } from '@roxi/routify';
	import { getData } from "../helpers.js";

	$afterPageLoad(page => {
		let resp = getData('user/passwordless-login', {'token': $params.token});
		resp.then(response => response.json())
		.then(ret_json => {
			if (ret_json.status === 'success') {
				$goto('./dashboard');
			} else {
				$goto('.login')
			}
		});
	})
</script>